import { useApiMutation } from "./use-api-mutation";

export interface DuplicateShopSettingsDto {
	targetShopId: string;
	carriers?: boolean;
	rules?: boolean;
	preferences?: boolean;
	users?: boolean;
	exchange?: boolean;
	discount?: boolean;
	reasons?: boolean;
	integrations?: boolean;
	returnToStore?: boolean;
}

export default function useDuplicateShopSettings(shopId: string) {
	return useApiMutation("post", "/shops/{shopId}/duplicate-settings" as never, {
		mapVariables: (requestBody: DuplicateShopSettingsDto) => ({
			params: { path: { shopId } },
			body: requestBody,
		}),
	});
}
